import { render, staticRenderFns } from "./NewAddressForm.vue?vue&type=template&id=a779c376"
import script from "./NewAddressForm.vue?vue&type=script&lang=js"
export * from "./NewAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports